import { Directive, ElementRef} from '@angular/core';


@Directive({
    selector: '[appFreeDraggingHandle]',
    standalone: false
})
export class FreeDraggingHandleDirective{

  constructor(public elementRef: ElementRef<HTMLElement>) {
  }

}
